<div class='row'>
  <div class='col-md-6'>
    <app-label label='Numer decyzji lokalizacyjnej:'>
      {{ occupation?.locationDecisionNumber }}
    </app-label>
  </div>
  <div class='col-md-6'>
    <app-label label='Data wydania decyzji lokalizacyjnej:'>
      {{ occupation?.locationDecisionDate | date }}
    </app-label>
  </div>
</div>
<br>
<dl>
  <dt class="mb-3">
    <strong>Etapy</strong>
  </dt>
  <dd>
    <ol>
      @for (stage of occupation?.stages; track $index) {
        <li>
          <div class="row">
            <div class="col-md-4">
              <app-label label="Miejscowość:">
                {{ stage.city }}
              </app-label>
            </div>
            @if (stage.roadNumber; as roadNumber) {
              <div class="col-md-4">
                <app-label label="Numer drogi:">
                  {{ roadNumber }}
                </app-label>
              </div>
            }
            @if (stage.roadName; as roadName) {
              <div class="col-12">
                <app-label label="Nazwa drogi:">
                  {{ roadName }}
                </app-label>
              </div>
            }
            @if (stage.street; as street) {
              <div class="col-md-8">
                <app-label label="Ulica:">
                  {{ street }}
                </app-label>
              </div>
            }
          </div>
          <br>
          <div class="row">
            <div class="col-12">
              <p class="mb-2">
                <strong>
                  Termin umieszczenia urządzenia w bieżącym roku
                </strong>
              </p>
            </div>
            <div class='col-md-4'>
              <app-label label='Data od:'>
                {{ stage.startDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Data do:'>
                {{ stage.endDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Ilość dni:'>
                {{ stage.dayQuantity }}
              </app-label>
            </div>
          </div>
          @if (stage.devicesProvidePlacementDeadline) {
            <br>
            <div class="row">
              <div class="col-12">
                <p class="mb-2">
                  <strong>
                    Termin umieszczenia urządzenia w kolejnych latach
                  </strong>
                </p>
              </div>
              <div class="col-md-4">
                <app-label label="Data od:">
                  {{ stage.nextYearsDateFrom | date }}
                </app-label>
              </div>
              <div class="col-md-4">
                <app-label label="Data do:">
                  {{ stage.nextYearsDateTo | date }}
                </app-label>
              </div>
              <div class="col-md-4">
                <app-label label="Ilość lat:">
                  {{ stage.yearsCount }}
                </app-label>
              </div>
            </div>
          }
          <br>
          <div class="row">
            <div class="col-12">
              <p class="mb-2">
                <strong>
                  Działki
                </strong>
              </p>
              <app-parcels-preview [parcels]="stage.parcels">
              </app-parcels-preview>
              <br>
            </div>
          </div>
          <app-location-of-devices-unrelated-to-road-stage-table [stage]="stage">
          </app-location-of-devices-unrelated-to-road-stage-table>
        </li>
        @if (!$last) {
          <hr>
        }
      }
    </ol>
  </dd>
</dl>
